import {
  TEACHER_TEST_TYPES_CONFIG,
  TEACHER_TEST_STATUS_CONFIG,
} from 'constants/teacher-details';

export const teacherLicenseImportMapper = (data = {}) => {
  const { tests = [], licenses = [], regions = [] } = data;

  return {
    tests: tests?.map(({ type, status }) => ({
      type: TEACHER_TEST_TYPES_CONFIG?.[type]?.label,
      status: TEACHER_TEST_STATUS_CONFIG?.[status]?.label,
    })),
    licenses: licenses?.map(({ grade_groups: gradeGroups, ...rest }) => ({
      ...rest,
      gradeGroups,
    })),
    regions,
  };
};
